import { useEffect, useState } from "react";

// utils
import axios from "../../utils/axios";
import priceListOpts from "../../utils/priceListOpts";
import merchantCategoryOpts from "../../utils/merchantCategoryOpts";
import countriesOpts from "../../utils/countriesOpts";

import { Container, Box, Alert, AlertTitle } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
//
import { useTranslation } from "react-i18next";

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorAlert, setErrorAlert] = useState(null);
  const [successAlert, setSuccessAlert] = useState(null);
  const { t, i18n } = useTranslation();

  const columns = [
    { field: "id", headerName: "ID", width: 50 },
    {
      field: "name",
      headerName: t("tables.users.name"),
      width: 120,
      editable: true,
    },
    {
      field: "surname",
      headerName: t("tables.users.surname"),
      width: 120,
      editable: true,
    },
    {
      field: "email",
      headerName: t("tables.users.email"),
      width: 200,
      editable: false,
    },
    {
      field: "price_list",
      headerName: t("tables.users.price_list"),
      width: 110,
      editable: true,
      type: "singleSelect",
      valueOptions: priceListOpts.map((item, index) => ({
        value: item.value,
        label: item.label,
      })),
    },
    {
      field: "role",
      headerName: t("tables.users.role"),
      width: 110,
      editable: true,
      type: "singleSelect",
      valueOptions: ["USER", "AGENT", "ADMIN"],
    },
    {
      field: "city",
      headerName: t("tables.users.city"),
      width: 110,
      editable: true,
    },
    {
      field: "country",
      headerName: t("tables.users.country"),
      width: 110,
      editable: true,
      type: "singleSelect",
      valueOptions: countriesOpts.map((item, index) => ({
        value: item.value,
        label: item.label,
      })),
    },
    {
      field: "province",
      headerName: t("tables.users.province"),
      width: 90,
      editable: true,
    },
    {
      field: "merchant_category",
      headerName: t("tables.users.name"),
      width: 150,
      editable: true,
      type: "singleSelect",
      valueOptions: merchantCategoryOpts.map((item, index) => ({
        value: item.value,
        label: item.label,
      })),
    },
  ];

  const getUsers = async () => {
    axios
      .post("/admin/users/list")
      .then((res) => {
        const users = res.data.users;
        setUsers(users);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setErrorAlert("Error getting users");
      });
  };

  const editUser = (id, field, value) => {
    axios
      .post(`/admin/users/edit/${id}`, { [field]: value })
      .then((res) => {
        const newUser = res.data.user;

        console.log(res);
        // update user in state
        setUsers(
          users.map((user) => (user.id === id ? (user = newUser) : user))
        );
        setLoading(false);
        setSuccessAlert(t(res.data.message));
        setTimeout(() => {
          setSuccessAlert(null);
        }, 3000);
      })
      .catch((err) => {
        console.error(err);

        if (err.status === 422) {
          setErrorAlert(Object.values(err.data)[0][0]);
        } else {
          setErrorAlert(t(err.data.message));
        }

        setTimeout(() => {
          setErrorAlert(null);
        }, 3000);
        setLoading(false);
      });
  };

  const onCellEditCommit = (params) => {
    setLoading(true);
    const { id, field, value } = params;
    editUser(id, field, value);
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <Container>
      <Box sx={{ height: 400, width: "100%" }}>
        {errorAlert && (
          <Box sx={{ mb: 2 }}>
            <Alert severity="error">{errorAlert}</Alert>
          </Box>
        )}
        {successAlert && (
          <Box sx={{ mb: 2 }}>
            <Alert severity="success">{successAlert}</Alert>
          </Box>
        )}

        <DataGrid
          rows={users}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          // checkboxSelection
          disableSelectionOnClick
          loading={loading}
          autoHeight
          autoPageSize
          onCellEditCommit={onCellEditCommit}
        />
      </Box>
    </Container>
  );
}
